/* eslint-disable react/no-array-index-key */
import React, { FC } from 'react';
import AUNotificationComponent from '@aarhus-university/au-lib-react-components/src/components/AUNotificationComponent';
import { getNotificationType } from '../../lib/helpers';

type validTypes = 'warning' | 'attention' | 'confirm';

type Props = {
  systemMessage: ISystemMessage;
};

const NotificationComponent: FC<Props> = ({
  systemMessage,
}) => {
  // eslint-disable-next-line max-len
  const renderActions = (systemMessage.actions || []).filter((a) => !!a.text).map((action) => {
    if (action.uri) {
      return (
        <a className="button" href={action.uri}>{action.text}</a>
      );
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{null}</>;
  });
  return (
    <AUNotificationComponent
      header={systemMessage.title}
      content={[<div dangerouslySetInnerHTML={{ __html: systemMessage.message }} />]}
      type={getNotificationType(systemMessage.severity) as validTypes}
      actions={renderActions}
    />
  );
};

NotificationComponent.displayName = 'NotificationComponent';
export default NotificationComponent;
